module.exports = __webpack_public_path__ + "img/logo.104483fa.svg";